angular.module('ikeweb.spike.measure').service('PhotoMeasureBuilder', ['PhotoMeasure', 'photogrammetryToolKit', 'promiseFactory', '$window', 'pubSubService', 'measureTopics', 'billingService',

    function(PhotoMeasure, photogrammetryToolKit, promiseFactory, $window, pubSubService, measureTopics, billingService) {

        function PhotoMeasureBuilder(deferredInstance) {

            var _capture, _imgElement, _svgElement, _measurementFormatter;

            function whenInstantiated() {
                return deferredInstance.promise;
            }

            function withCapture(capture) {
                _capture = capture;
                return this;
            }

            function withImgElement(imgElement) {
                _imgElement = imgElement;
                return this;
            }

            function withSVGElement(svgElement) {
                _svgElement = svgElement;
                return this;
            }

            function withMeasurementFormatter(measurementFormatter) {
                _measurementFormatter = measurementFormatter;
                return this;
            }

            function build() {
                var photoMeasure = new PhotoMeasure(photogrammetryToolKit, $window, _capture, _imgElement, _svgElement, _measurementFormatter, pubSubService, measureTopics, billingService);
                deferredInstance.resolve(photoMeasure);
                return deferredInstance.promise;
            }

            return {
                whenInstantiated: whenInstantiated,
                withCapture: withCapture,
                withImgElement: withImgElement,
                withSVGElement: withSVGElement,
                withMeasurementFormatter: withMeasurementFormatter,
                build: build
            };
        }

        this.create = function() {
            return new PhotoMeasureBuilder(promiseFactory.deferredValue());
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/photo-measure/photo.measure.builder.js
// module id = 566
// module chunks = 0